// Auto-generated skeleton for EmailRecipient

export const EmailRecipient: Api.EmailRecipient = {
  id: 0,
  name: null,
  email: '',
};

